var env = process.env.REACT_APP_ENV || "development";

var baseUrl = "https://api.e-guma.ch/v1/home/";

/*
if (env === "development") {
  baseUrl = "http://localhost:4040/v1/home/";
}
*/

export { baseUrl };
